import React from "react";
import { buildDocUrl, openDocument } from "modules/patient/helper/documentConstants";

// A patient document — the Rx PDF mapped to an appointment. Files under
// /files/patient/… are token-gated, so the raw URL is a 403: the doc token
// (minted when the case page opens, as the patient record's documents menu
// does) is appended at click time, so a token minted after render still counts.
export default function DocumentLink({ url, children }) {
  if (!url) return "-";
  return (
    <a
      href={buildDocUrl(url)}
      target="_blank"
      rel="noopener noreferrer"
      className="ltr-orange-link"
      onClick={(e) => {
        e.preventDefault();
        openDocument({ url });
      }}
    >
      {children || "View document"}
    </a>
  );
}
